﻿import React, {FC} from 'react';
import { BoundSearchQuery } from "../../../types/common/BoundSearchQuery";
import { BuyerInventorySearchCriteria } from "../../../types/model/criteria/inventory/BuyerInventorySearchCriteria";
import { PageableParams } from "../../../types/model/params/PageableParams";
import { optionsEndpoints } from "../../../requests/api-endpoints";
import {
  SortFilterContainer,
  SortFilterItemContainer,
  SortFilterRowContainer
} from "../../common/reports/sortFilter";
import {
  sortByFields,
  BuyerInventorySortByType,
  BuyerInventorySortParams
} from "../../../types/model/params/sortParams/BuyerInventorySortParams";
import {
  BoundSortSelect,
  BoundDataDrivenAutocomplete,
  BoundAssetTypeAutocomplete,
  BoundTextInput
} from "../../common/inputs/boundInputs";

export interface BuyerCurrentInventorySearchParams extends BuyerInventorySearchCriteria, BuyerInventorySortParams, PageableParams, BoundSearchQuery {}

export interface BuyerCurrentInventorySortFilterProps {
  query: BuyerCurrentInventorySearchParams;
  onChange: (newQuery: BuyerCurrentInventorySearchParams) => void;
}

const BuyerCurrentInventorySortFilter: FC<BuyerCurrentInventorySortFilterProps> = ({
  query,
  onChange
}) => {

  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<BuyerCurrentInventorySearchParams>
          label="Location"
          requestUrl={optionsEndpoints.buyer.inventoryLocation}
          name="locationId"
          value={query?.locationId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundAssetTypeAutocomplete<BuyerCurrentInventorySearchParams>
          label="Equipment Type"
          name="equipmentType"
          value={query?.equipmentType}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundTextInput<BuyerCurrentInventorySearchParams>
          label="Booking Number"
          name="bookingNumber"
          value={query?.bookingNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundTextInput<BuyerCurrentInventorySearchParams>
          label="Equipment Number"
          name="equipmentNumber"
          value={query?.equipmentNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundSortSelect<BuyerCurrentInventorySearchParams, BuyerInventorySortByType>
          query={query}
          defaultSortBy="CHECK_IN_DATE"
          defaultSortDir="desc"
          sortByFields={sortByFields}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { BuyerCurrentInventorySortFilter };
